export const salesRoutes = {
	saleIndex: '/sales',
	saleEdit: (id?: string) => `/sales/${id ?? ':id'}`,
	saleHistory: (id?: string) => `/sales/${id ?? ':id'}/history`
} as const
